import styled from 'styled-components';

export const DEFAULT_WAVEFORM_HEIGHT = 30;
export const DEFAULT_WAVEFORM_CONTAINER_HEIGHT = 60;

export const WaveformContainer = styled.div<{ small?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: ${props =>
    props.small ? '40px' : DEFAULT_WAVEFORM_CONTAINER_HEIGHT + 'px'};
  width: 100%;
  background: #180d23;
  padding: ${props => (props.small ? '5px' : '8px')};
  box-sizing: border-box;
  border: 1px solid #00000000;
  background: #251a30;
  border-radius: 8px;
  overflow: hidden;

  &:hover {
    padding: ${props => (props.small ? '5px' : '8px')};
    border: 1px solid #ff74e933;
  }
`;

export const Wave = styled.div<{ small?: boolean }>`
  width: 100%;
  height: ${props => (props.small ? '40px' : DEFAULT_WAVEFORM_HEIGHT + 'px')};
  overflow: hidden; /* Prevent any scrolling */
  
  /* Hide scroll bars */
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  /* For Firefox */
  scrollbar-width: none;
  
  /* For IE and Edge */
  -ms-overflow-style: none;
  
  /* Additional fallback */
  & * {
    &::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`;

export const PlayButton = styled.button<{ small?: boolean; hidePlayButtonBackground?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => (props.small ? '30px' : '40px')};
  height: ${props => (props.small ? '30px' : '40px')};
  background: ${props => (props.hidePlayButtonBackground ? 'none' : '#F5E1FF')};
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  padding-bottom: 3px;
  margin-right: ${props => (props.small ? '5px' : '10px')};
  color: #0c0810;
  z-index: 100;
  flex-shrink: 0;
  &:hover {
    background: #ff74e9;
  }
`;
export const RightButton = styled.div<{ small?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${props => (props.small ? '5px' : '10px')};
  height: ${props => (props.small ? '30px' : '40px')};
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  flex: unset !important;
  // For FontAwesomeIcon
  font-size: ${props => (props.small ? '30px' : '40px')};

  .fa-check {
    color: #55cdc4;
    max-width: 24px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
export const DownloadButton = styled.a`
  color: #f5e1ff;
  &:hover {
    color: #ff74e9;
  }
`;

export const WaveformAndHeaderWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

export const WaveformTitleAndDuration = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

export const WaveformTitle = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 16px;
  text-align: left;
  padding-bottom: 0;
  margin-bottom: 0;
  /* start hacky fix for overflowing waveform when long filename */
  flex-shrink: 1;
  flex-grow: 1;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  width: 100%;
  display: block;

  @media only screen and (max-width: 700px) {
    max-width: 280px;
  }
  /* end */
`;

export const WaveformDuration = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 16px;
  text-align: left;
  flex-shrink: 0;
  margin-left: 8px;
  flex: unset !important;
`;
